import { createContext, useContext, useState, useMemo } from 'react';

// Create a Context
const ImagesProviderContext = createContext();

// Custom hook to use the Context
export const useImages = () => {
    return useContext(ImagesProviderContext);
};

// Provider component
export const ImagesProvider = ({ children }) => {
    const [backgrounds, setBackgrounds] = useState([]);
    const [links, setLinks] = useState([]);
    const [showcases, setShowcases] = useState([]);
    const [avatars, setAvatars] = useState([]);
    const [showCaseGlow, setShowCaseGlow] = useState(false);
    const [playerViewSharedImage, setPlayerViewSharedImage] = useState(null);

    const value = useMemo(() => ({ 
        links, setLinks, 
        avatars, setAvatars, 
        backgrounds, setBackgrounds, 
        showcases, setShowcases,
        showCaseGlow, setShowCaseGlow,
        playerViewSharedImage, setPlayerViewSharedImage,
    }), [links, avatars, backgrounds, showcases, showCaseGlow, playerViewSharedImage]);

    return (
        <ImagesProviderContext.Provider value={value}>
            {children}
        </ImagesProviderContext.Provider>
    );
};